import styled from "@emotion/styled";

export const LayoutWrapper = styled.div`
  min-height: 100vh;
  background-color: ${({ theme }) => theme.colors.background};
  display: flex;
  flex-direction: column;
`;

export const Main = styled.main`
  min-height: 280px;
  padding: 0 0 50px;
  flex: 1;

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    padding: 0 0 70px;
  }
`;
